module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/connect-mobile-26428d63cd8fa631f5bad9d6629658ee.webp";